import type { ReactNode } from 'react';
import type { VideoRequest } from '../../services/local-video';
import { resolveRenderPreset } from '../../domain/render-preset';
import { frameTimecode } from '../../domain/frame-timecode';
import { resolveExportTiming } from '../../../../renderer/src/export-range';
import type { Task } from './tasks';
import { CompositionIssueNotice } from './CompositionIssueNotice';
import type { CompositionIssue } from './composition-issue';
import { cinematicKeyCount } from '../../../../renderer/src/cinematic-sequence';

export function ExportPanel({ request, ready, error, issue, onShowIssue, onRepairIssue, onDownload, onTask, children }: {
  request: VideoRequest; ready: boolean; error: string; issue: CompositionIssue | undefined;
  onShowIssue: () => void; onRepairIssue: () => void; onDownload: () => void; onTask: (task: Task) => void; children: ReactNode;
}) {
  const timing = resolveExportTiming(request); const format = resolveRenderPreset(request.preset);
  return <>
    <div className="panel-intro"><h1>Export MP4</h1></div>
    <CompositionIssueNotice issue={issue} onShow={onShowIssue} onRepair={onRepairIssue} />
    <div className="export-spec"><span>{format.width} × {format.height}</span><strong>{timing.durationSeconds.toFixed(1)}<small>seconds</small></strong><p>{format.label} · 30 fps · H.264</p></div>
    {children}
    <details className="export-review-details"><summary>Review film details</summary><dl className="review-list"><div><dt>Trace title</dt><dd>{request.ride.title}<button className="text-button" onClick={() => onTask('ride')}>Edit title</button></dd></div>
      <div><dt>Selected footage</dt><dd>{frameTimecode(timing.sourceFrames)} · five-second minimum</dd></div>
      <div><dt>Export duration</dt><dd>{frameTimecode(timing.outputFrames)}</dd></div>
      <div><dt>Camera changes</dt><dd>{cinematicKeyCount(request.cinematicSequence)} keyframes<button className="text-button" onClick={() => onTask('camera')}>Review camera</button></dd></div>
      <div><dt>Audio</dt><dd>No audio</dd></div></dl></details>
    {error ? <p className="inline-notice" role="alert">{error}</p> : <p className="check-line" role="status">{ready ? 'Preview is up to date.' : 'Updating your preview…'}</p>}
    <button className="text-button wide" onClick={onDownload}>Download composition</button>
    <p className="help">The composition keeps your original trace, selected footage, format, and camera changes together.</p>
  </>;
}
